export const comments_4791867 = {"data":{"data":[],"links":{}}}